import FileDownload from './file-download'

export default {
  install (Vue) {
    Vue.component('FileDownload', FileDownload)
  }
}
